<div class="map-wrapper">
  <div #mapContainer class="map-container" [style.height]="height">
    <div class="map-loading" *ngIf="!mapLoaded">
      <i class="pi pi-spin pi-spinner"></i>
      <span style="color: #0B0C0E">Loading map...</span>
    </div>
  </div>

  <div #overlayTooltip class="overlay-layer-tooltip"></div>


  <!-- Zoom Controls -->
  <div class="zoom-controls">
    <button pButton class="p-button-rounded p-button-text" (click)="zoomIn()" [pTooltip]="'Zoom In' | translate"
            tooltipPosition="top" appendTo="body" tooltipStyleClass="request-map-control-tooltip">
      <i class="pi pi-plus"></i>
    </button>
    <button pButton class="p-button-rounded p-button-text" (click)="zoomOut()" [pTooltip]="'Zoom Out' | translate"
            tooltipPosition="top" appendTo="body" tooltipStyleClass="request-map-control-tooltip">
      <i class="pi pi-minus"></i>
    </button>
  </div>


  @if (showControls) {
    <div class="draw-control">
      <!--    <button-->
      <!--      pButton-->
      <!--      class="p-button-rounded p-button-text"-->
      <!--      [class.active]="drawingMode"-->
      <!--      (click)="toggleDrawing()">-->
      <!--      <i class="pi pi-pencil"></i>-->
      <!--    </button>-->
      <button
        pButton
        class="p-button-rounded p-button-text" [pTooltip]="'Center Map' | translate" tooltipPosition="top"
        appendTo="body" tooltipStyleClass="request-map-control-tooltip"
        [class.active]="drawingMode"

        (click)="centerMap()">
        <img
          [src]="'map-center' | iconPath"
          alt="Map"
          class="map-icon"
        />
      </button>
    </div>
    <!-- Image Control -->
    <div class="image-control">
      @if (overlayLayerToggle) {
        <button
          pButton
          class="p-button-rounded p-button-text"
          [class.active]="overlayLayerVisible"
          [pTooltip]="overlayLayerLabel | translate" tooltipPosition="left"
          appendTo="body" tooltipStyleClass="request-map-control-tooltip"
          (click)="toggleOverlayLayer()">
          <i class="pi pi-clone"></i>
        </button>
      }

      @if (drawingOptions.point) {
        <button
          pButton
          class="p-button-rounded p-button-text" [pTooltip]="'Draw Point' | translate" tooltipPosition="left"
          appendTo="body" tooltipStyleClass="request-map-control-tooltip"
          (click)="stopPolygonDrawing()">
          <img
            [src]="'map-draw-point' | iconPath"
            alt="Map"
            class="map-icon"
          />
        </button>
      }

      @if (drawingOptions.polygon) {
        <button
          pButton
          class="p-button-rounded p-button-text" [pTooltip]="'Draw Polygon' | translate" tooltipPosition="left"
          appendTo="body" tooltipStyleClass="request-map-control-tooltip"
          (click)="stopPolygonDrawing();startPolygonDrawing()">
          <img
            src="assets/icons/main/light/sixers-black.svg"
            style="height: 20px; width: 20px;"
            alt="Map"
            class="map-icon"
          />
        </button>
      }

    </div>
  }

  @if (showMapSwitcher) {
    <div class="map-switcher-control flex flex-row gap-2 align-items-start">
      <div class="layer-switcher-container">
        <button
          type="button"
          class="layer-btn"
          [class.active]="isPlanLayerActive"
          (click)="selectPlanLayer()"
          [title]="'PLAN' | translate">
          <span>{{ 'PLAN' | translate }}</span>
        </button>

        <div class="satellite-btn-wrapper">
          <button
            type="button"
            class="layer-btn satellite-main-btn"
            [class.active]="!isPlanLayerActive"
            [title]="currentSatelliteLabel | translate"
            (click)="satelliteSelectorVisible = !satelliteSelectorVisible">
            <span>{{ currentSatelliteLabel | translate }}</span>
            <i class="pi pi-chevron-up"></i>
          </button>
          <app-satellite-style-selector
            [styles]="satelliteMenuItems"
            [selected]="isPlanLayerActive ? null : currentBaseLayer"
            [visible]="satelliteSelectorVisible"
            (select)="selectSatelliteLayer($event)"
            (close)="satelliteSelectorVisible = false"
          ></app-satellite-style-selector>
        </div>
      </div>
    </div>
  }

</div>

